export const productVariants = {
  prod_JzPlmDSdAjd2p6: ["quantity", "frequency"],
  prod_JzgitGwlJPWAtV: ["quantity", "frequency"],
  prod_KWPnD566MBSF3V: ["quantity", "frequency"],
  prod_KWPbd5ELZXLu1c: ["quantity", "frequency"]
};
